import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appDecimal]',
  standalone: true,
})
export class DecimalDirective {
  @Input() appDecimal: boolean = true;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInputEvent(event: any) {
    if (this.appDecimal) {
      this.el.nativeElement.value = this.el.nativeElement.value?.replace(
        /[^0-9.]/g,
        '',
      );
      const decimalCount = this.el.nativeElement.value?.split('.').length - 1; // Count the number of decimal points
      if (decimalCount > 1) {
        this.el.nativeElement.value = this.el.nativeElement.value?.replace(
          /\.([^.]*)$/,
          '$1',
        );
      }
    }
  }

  @HostListener('paste', ['$event']) onPasteEvent(event: ClipboardEvent) {
    if (this.appDecimal) {
      event.preventDefault();
      const pastedText = (
        event.clipboardData || (window as any).clipboardData
      ).getData('text');
      this.el.nativeElement.value = pastedText.replace(/[^0-9.]/g, '');
      const decimalCount = this.el.nativeElement.value.split('.').length - 1; // Count the number of decimal points
      if (decimalCount > 1) {
        this.el.nativeElement.value = this.el.nativeElement.value.replace(
          /\.([^.]*)$/,
          '$1',
        );
      }
    }
  }

  @HostListener('drop', ['$event']) onDropEvent(event: DragEvent) {
    if (this.appDecimal) {
      event.preventDefault();
      const droppedText = event.dataTransfer?.getData('text');
      this.el.nativeElement.value = droppedText?.replace(/[^0-9.]/g, '');
      const decimalCount = this.el.nativeElement.value.split('.').length - 1; // Count the number of decimal points
      if (decimalCount > 1) {
        this.el.nativeElement.value = this.el.nativeElement.value.replace(
          /\.([^.]*)$/,
          '$1',
        );
      }
    }
  }
}
